export const environment = {
  apiUrl: 'https://dev.api.idownsize.com.au',
  appUrl: 'https://dev.idownsize.com.au',
  googleMapsApiKey: 'AIzaSyCJ9dpbq9qyLWGgTjfxa2hlUjPbeZD5G_Y',
  stripeKey:
    'pk_test_51Qn1rd2LgdJysGx67LzTpqAxrcJJmfuh3k0rORxCQXnVoeQqzD2pMD1LwHihVegFAIYn1N9ClLVKTc10EiDBodRQ00k2wOpo5c',
  production: false,
  imageUrl:
    'https://idownsize-home-images.s3.ap-southeast-2.amazonaws.com/properties/',
  baseImageUrl:
    'https://idownsize-home-images.s3.ap-southeast-2.amazonaws.com/',
};
